import { Button } from '@material-ui/core'
import { FormikProvider, useFormik } from 'formik'
import React from 'react'
import CustomFormikInput from 'src/components/form-components/CustomFormikInput'
import FormikCheckbox from 'src/components/form-components/FormikCheckbox'
import FormikTextField from 'src/components/form-components/FormikTextField'
import FileInput from 'src/components/form-components/FileInput'
import { StyledForm } from 'src/components/form-components/styled-basics'
import { SuitCategory } from 'src/entities/SuitCategory'
import { CRUDFormProps } from '../types'
import validationSchema from './validation'

export type SuitCategoryFormData = Omit<SuitCategory, 'image_src'> & {
  image_src: File | string
}

const SuitCategoryForm = ({
  item,
  onSubmit,
}: CRUDFormProps<SuitCategory, SuitCategoryFormData>) => {
  const formik = useFormik({
    initialValues: {
      name: item?.name ?? '',
      description: item?.description ?? '',
      image_src: item?.image_src ?? '',
      _enabled: item?._enabled ?? true,
    },
    validationSchema,
    onSubmit,
  })
  const { handleSubmit, values, setFieldValue, errors } = formik

  console.log(values)

  return (
    <FormikProvider value={formik}>
      <StyledForm>
        <FormikCheckbox name='_enabled' label='Enabled' />

        <FormikTextField name='name' label='Name' />

        <FormikTextField
          style={{ width: 300 }}
          name='description'
          label='Description'
        />

        <CustomFormikInput name='image_src' label='Image'>
          {({ value, ...inputProps }) => (
            <FileInput
              type='file'
              onChange={({ currentTarget }) => {
                // @ts-expect-error
                setFieldValue(inputProps.name, currentTarget.files[0])
              }}
              // @ts-expect-error
              file={values.image_src}
              {...inputProps}
            />
          )}
        </CustomFormikInput>

        <Button
          variant='contained'
          color='primary'
          onClick={() => handleSubmit()}
        >
          Submit
        </Button>
      </StyledForm>
    </FormikProvider>
  )
}

export default SuitCategoryForm
